import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";

export default store => ({
  path: TRANSCRIPT_ROUTES.STUDENTS,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-students" */ "./components"
    ).then(m => m.default)
  ),
});
